import useFetchTypes from "./useFetchTypes";
import { FILTER_TYPES } from "../dao/types";

export default function useProjectTypes() {
  // useFetchTypes already filters out items with blank description
  return useFetchTypes(FILTER_TYPES.project);
}
